import { Badge } from "@/components/ui/badge";

/**
 * Downtime Type Badge Component
 * Displays a badge indicating the mechanical type of a downtime event
 * @param {Object} props
 * @param {number} props.type - The type value: 0 = Unknown, 1 = Mech, 2 = Non-Mech
 * @returns {JSX.Element} Badge component
 */
export default function DowntimeTypeBadge({ type }) {
  if (type === 0 || type === undefined || type === null) {
    return (
      <Badge
        variant='secondary'
        className='bg-muted text-muted-foreground border-border'>
        Unknown
      </Badge>
    );
  }

  if (type === 1) {
    return (
      <Badge
        variant='outline'
        className='bg-blue-50 text-blue-700 border-blue-300'>
        Mech
      </Badge>
    );
  }

  // type === 2
  return (
    <Badge
      variant='outline'
      className='bg-yellow-50 text-yellow-700 border-yellow-300'>
      Non-Mech
    </Badge>
  );
}
